/**
 * Front route declaration, with their associated component
 * @see {@link https://router.vuejs.org/guide/essentials/named-routes.html|Vue Router Named Route}
 */

export default [
    {
        path: '/?_f=catalogueitem&id=:id',
        name: 'legacy.product.overview',
    },
    {
        path: '/rest/item/:id/:type',
        name: 'legacy.item.save'
    },
]